import { render, staticRenderFns } from "./sider-menu.vue?vue&type=template&id=7fd0b424&scoped=true&"
import script from "./sider-menu.vue?vue&type=script&lang=js&"
export * from "./sider-menu.vue?vue&type=script&lang=js&"
import style0 from "./sider-menu.vue?vue&type=style&index=0&id=7fd0b424&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd0b424",
  null
  
)

export default component.exports